import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { DataToSendDichiarazione } from '../../dischiarazione.models';
import { DichiarazioneService } from '../../services/dichiarazione.service';

@Component({
    selector: 'fb-dettagli-contributi-versati',
    templateUrl: './dettagli-contributi-versati.component.html',
    styleUrls: ['./dettagli-contributi-versati.component.scss'],
})
export class DettagliContributiVersatiComponent implements OnInit, OnDestroy {
    contributiVersati: { descrizione: string; importo: number }[] = [];

    private unsubscribeAll = new Subject<void>();

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: { dataToSendDichiarazione: DataToSendDichiarazione },
        public dialogRef: MatDialogRef<DettagliContributiVersatiComponent>,
        private dichiarazioneService: DichiarazioneService
    ) {}

    ngOnDestroy(): void {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }

    ngOnInit(): void {
        this.caricaDati().pipe(takeUntil(this.unsubscribeAll)).subscribe();
    }

    private caricaDati() {
        return this.dichiarazioneService
            .getDettagliContributiVersati(this.data.dataToSendDichiarazione.forfettarioId, this.data.dataToSendDichiarazione.anno)
            .pipe(
                map(contributiVersati => {
                    this.contributiVersati = [
                        {
                            descrizione: `1° acconto INPS da versare calcolato in UNICO${this.data.dataToSendDichiarazione.anno}`,
                            importo: contributiVersati.primoAccontoContributivoAnnoPrecedente,
                        },
                        {
                            descrizione: `2° acconto INPS da versare calcolato in UNICO${this.data.dataToSendDichiarazione.anno}`,
                            importo: contributiVersati.secondoAccontoContributivoAnnoPrecedente,
                        },
                    ];
                })
            );
    }
}
